import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';
import "./AccordionStyle.css";
import { CardMedia, Grid } from '@mui/material';

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

interface props {
    data?: any,
    onClink?: any,
    onExpanded?: boolean, //false = เปิด หรือ true = ปิด ไว้
}

const CustomizedAccordions: React.FC<props> = ({ data, onExpanded }) => {
    const [expanded, setExpanded] = React.useState<string | false>();

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        };

    const options = {
        replace: (domNode) => {
            if (domNode.attribs && domNode.attribs.class === 'remove') {
                return <></>;
            }
        },
    };

    return (
        <div>
            {(data || []).length > 0 ?
                data.map((row, index) => (
                    <Accordion key={"panel" + index} expanded={expanded === "panel" + index} onChange={handleChange("panel" + index)}>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                            <Typography>{row.sFAQQuestion}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {/* {(row.lstContent || []).length > 0 &&
                                row.lstContent.map((item, nItem) => (
                                    <Typography key={`faq-k${nItem}`} className="FAQ-Answer">
                                        {item.nTypeID == 1 &&
                                            parse(item.sContent)
                                        }
                                        {item.nTypeID == 2 &&
                                            <img src={item.sFileLink} width="100%" />
                                        }
                                    </Typography>
                                ))} */}

                            {(row.lstContent || []).length > 0 &&
                                row.lstContent.map((item, nItem) => {
                                    if (item.nTypeID == 1) {
                                        // sTypeText : "ข้อความ"
                                        return (
                                            <Typography key={`faq-k${nItem}`} className="FAQ-Answer">
                                                {parse(item?.sContent, options)}
                                            </Typography>
                                        )
                                    }
                                    else if (item.nTypeID == 2) {
                                        // sTypeText : "รูป"
                                        return (
                                            <Typography key={`faq-k${nItem}`} className="FAQ-Answer">
                                                <img src={item.sFileLink} alt="" width="100%" />
                                            </Typography>
                                        )
                                    }
                                    else if (item.nTypeID == 3) {
                                        // sTypeText : "วีดีโอ"
                                        return (
                                            <Typography key={`faq-k${nItem}`} className="FAQ-Answer">
                                                <CardMedia
                                                    className='youtube-style'
                                                    component="video"
                                                    controls
                                                    height="400px"
                                                    src={item.sFileLink}
                                                />
                                            </Typography>
                                        )
                                    }
                                    else if (item.nTypeID == 4 && item?.sURL != undefined && item?.sURL != null ) {
                                        // sTypeText : "Youtube"
                                        return (
                                            <Typography key={`faq-k${nItem}`} className="FAQ-Answer">
                                                <CardMedia
                                                    className='youtube-style'
                                                    component="iframe"
                                                    allow={"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"}
                                                    allowFullScreen
                                                    frameBorder={0}
                                                    src={(item?.sURL || "").includes("watch?")
                                                    ? `https://www.youtube.com/embed/${(item?.sURL || "").split("/")[(item?.sURL || "").split("/").length - 1].split("=", (item?.sURL || "").split("/")[(item?.sURL || "").split("/").length - 1].length)[1]}`
                                                    : `https://www.youtube.com/embed/${(item?.sURL || "").split("/")[(item?.sURL || "").split("/").length - 1]}`}
                                            />
                                            </Typography>
                                        )
                                    }
                                })}
                        </AccordionDetails>
                    </Accordion>
                )) : null
            }
        </div>
    );
}

export default CustomizedAccordions